// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"359":"d9b94e37","580":"6fd43b01","873":"0c92190a","921":"88977c38"}[chunkId] + ".chunk.css";
};